const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "m 50,960.36217 c -12.690108,0 -23,10.30989 -23,23 l 0,11.00003 -5,0 c -3.826109,0 -7,3.1739 -7,7 l 0,36 c 0,3.8261 3.173891,7 7,7 l 56,0 c 3.82611,0 7,-3.1739 7,-7 l 0,-36 c 0,-3.8261 -3.17389,-7 -7,-7 l -5,0 0,-11.00003 c 0,-12.69011 -10.30989,-23 -23,-23 z m 0,6 c 9.46989,0 17,7.53011 17,17 l 0,11.00003 -34,0 0,-11.00003 c 0,-9.46989 7.530108,-17 17,-17 z m -28,34.00003 56,0 c 0.60589,0 1,0.3941 1,1 l 0,36 c 0,0.6059 -0.39411,1 -1,1 l -56,0 c -0.605893,0 -1,-0.3941 -1,-1 l 0,-36 c 0,-0.6059 0.394107,-1 1,-1 z m 28,6 c -4.935029,0 -9,4.065 -9,9 0,2.0459 0.837303,3.8249 2,5.3437 l 0,4.6563 c 0,3.8261 3.173892,7 7,7 3.82611,0 7,-3.1739 7,-7 l 0,-4.6563 c 1.1627,-1.5188 2,-3.2978 2,-5.3437 0,-4.935 -4.06497,-9 -9,-9 z m 0,6 c 1.69239,0 3,1.3076 3,3 0,0.9054 -0.38077,1.6641 -1,2.2187 a 3.0003,3.0003 0 0 0 -1,2.25 l 0,5.5313 c 0,0.6059 -0.394108,1 -1,1 -0.605892,0 -1,-0.3941 -1,-1 l 0,-5.5313 a 3.0003,3.0003 0 0 0 -1,-2.25 c -0.619231,-0.5546 -1,-1.3133 -1,-2.2187 0,-1.6924 1.307609,-3 3,-3 z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b5cebb4939a1453ad818cc1c012c88f6.svg";
export { ForwardRef as ReactComponent };